@if (showInstallOnDashboard()) {
<lib-message [dismissId]="'DashboardInstall'" [type]="'tip'" [title]="'Install app'" [className]="'push-bottom-md'">
	<div>Get the most from the app by using it on your phone / tablet.</div>

	<div class="push-top-sm">
		<mod-install-button [buttonType]="'basic'"></mod-install-button>
	</div>
</lib-message>
}

<lib-message [className]="'push-bottom-md'" [dismissId]="'DashboardContactUs'" [type]="'tip'" [title]="'Helpdesk'">
	<div>For any questions, feel free to contact us using the helpdesk button below.</div>

	<div class="push-top-sm">
		<lib-button [icon]="'helpdesk'" [routerLink]="helpdeskLink()">Contact us</lib-button>
	</div>
</lib-message>

<div [libFlexRow]="isMobileOrTabletView()" [libFlexRowAlign]="'start'">
	<div libFlexColumn [libFlexSize]="isMobileOrTabletView() ? 'full' : 'fill'">
		<lib-card [title]="'Upcoming appointments'">
			<lib-list
				[showNameBasedAvatar]="true"
				[items]="upcomingAppointments()"
				[disableSort]="true"
				[noItemsText]="'You have no upcoming appointments'"
			></lib-list>
		</lib-card>

		<lib-card [title]="'Latest feeds'" class="push-top-md">
			<lib-list
				[showNameBasedAvatar]="true"
				[disableSort]="true"
				[items]="latestFeeds()"
				[noItemsText]="'You have no feeds'"
			></lib-list>
		</lib-card>
	</div>

	<div libFlexColumn [libFlexSize]="isMobileOrTabletView() ? 'full' : 'fill'">
		<lib-card [title]="'Latest active clients'">
			<lib-list
				[showNameBasedAvatar]="true"
				[disableSort]="true"
				[items]="latestActiveClients()"
				[noItemsText]="'You have no active clients'"
			></lib-list>
		</lib-card>

		<lib-card class="push-top-md" [title]="'Latest messages'">
			<lib-list
				[showNameBasedAvatar]="true"
				[disableSort]="true"
				[items]="latestMessages()"
				[noItemsText]="'You have no messages'"
			></lib-list>
		</lib-card>
	</div>
</div>
